import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";
import { truncar } from "../../Helpers/Truncar";
import { number } from "echarts";


export const SimuladorIncentivosGerenteOR = ({ rango = null, sueldo = 0, ponderacion = 0, setTotal, tipoCalculo = 'N' }) => {

    const [state, setState] = useState({
        meta: 0,
        real: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };

    useEffect(() => {
        let cumplimiento = 0;
        let porcentaje = 0;
        let incentivo = 0;
        if (tipoCalculo === 'GS' && Number(state.meta) === 0 && Number(state.real) > 120000) {
            cumplimiento = 100
            // porcentaje = .08
            porcentaje = (rango.filter(item => item.minimo <= 100 && item.maximo >= 100)[0].porcentaje) * 0.8;
            incentivo = Number(sueldo) * porcentaje;
        }
        else if (Number(state.meta !== 0) && Number(state.real !== 0)) {
            cumplimiento = truncar((Number(state.real) / Number(state.meta)) * 100);
            // const porcentajeIncentivo = cumplimiento < 80 ? 0 : cumplimiento * ponderacion / 100;
            porcentaje = 0;
            incentivo = 0;
            if (rango !== null) {
                rango.forEach((index) => {
                    if (index.minimo <= cumplimiento && index.maximo >= cumplimiento) {
                        // porcentaje = cumplimiento > 150 ? index.porcentaje * 1.5 : index.porcentaje * cumplimiento / 100;
                        // porcentajeIncentivo = 25 * cumplimiento
                        porcentaje = index.porcentaje;
                        incentivo =
                            (Number(sueldo)) * porcentaje;
                    }
                });
            }
        }

        setState({
            ...state,
            cumplimiento,
            porcentaje: porcentaje * 100,
            incentivo,
        });

        setTotal(incentivo)
    }, [state.meta, state.real, sueldo]);

    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Objetivo de venta</div>
                    <SimuladorNumericInput
                        name="meta"
                        label=""
                        value={state.meta}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">Venta real</div>
                    <SimuladorNumericInput
                        name="real"
                        label=""
                        value={state.real}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
            </div>
            <div className="input-container-duo">
                <div className="input-section">
                    <div className="input-title-label">Cumplimiento de venta</div>
                    <SimuladorNumericInput
                        name="cumplimiento"
                        label=""
                        value={state.cumplimiento}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
                <div className="input-section">
                    <div className="input-title-label">% incentivo a ganar</div>
                    <SimuladorNumericInput
                        name="porcentaje"
                        label=""
                        value={state.porcentaje}
                        disabled={true}
                        align="centro"
                        icono="porcentaje"
                    />
                </div>
            </div>
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label-incentive">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div>
    );
};
